import { Injectable } from '@angular/core';
import { createQueryParams } from '@fullyops/shared/util/create-query-params';

@Injectable({
  providedIn: 'root',
})
export abstract class UiServiceV2 {
  protected createQueryParams = createQueryParams;
}
